;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import type { ApiResponse } from '@workspace/ui/types';
import fetchAPI from '@/lib/fetch-api';
import type { GigWorkerEarningSource } from '@/types/gig-workers';

export async function getGigWorkerEarningSources(): Promise<ApiResponse<GigWorkerEarningSource[]>> {
  const apiUrl = process.env.NEXT_PUBLIC_EOR_API_URL;

  if (!apiUrl) {
    throw new Error('[getGigWorkerEarningSources] NEXT_PUBLIC_EOR_API_URL is not set');
  }

  const response = await fetchAPI<GigWorkerEarningSource[]>(
    `${apiUrl}/gig-worker-earning-sources`,
    {
      method: 'GET',
      cache: 'force-cache',
    }
  );

  if (!response.success && (!response.status || ![200, 201].includes(response.status))) {
    throw new Error(
      response.error || response.message || 'Failed to fetch gig worker earning sources'
    );
  }

  return {
    ...response,
    message: response.message || 'Gig worker earning sources fetched successfully',
  };
}
